<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
// import Search from "@/components/c-select-search";
import { customerService } from "../../../services/contactservice/customer.service";
import { propertyService } from "../../../services/propertyservice/property.service";
import { bookingService } from "../../../services/bookingservice/booking.service";
import i18n from "../../../i18n";
import Loader from "../../../components/widgets/loader";

/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Property Booked Delay",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loader, 
    Button,
    Input,
    Area,
    // Search
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      currency: "",
      breadCrumb: {},
      selectCustomer: null,
      propertyData: null,
      customerData: {},
      customerSelected: {},
      dataCustomer: '',
      dataCode: '',
      dataNotation: '',
      dataExpired: this.$moment().format('YYYY-MM-DD'),
    };
      
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingCustomerData();

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 

  },

  methods: {
    loadingData: function(id) {
      // console.log("AAAAAA", id);
      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          // console.log(response);

          if(response.data == null) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "property-add"
            });
          }

          this.breadCrumb = {
            text: response.data.code,
            active: true,
          };

          this.fetchingStats = true;
          this.propertyData = response;

          this.loadingCustomerById( this.propertyData.data.temp_customer_id);

          this.dataCode = this.propertyData.data.code;
          this.dataNotation = this.propertyData.data.temp_note;
          this.dataExpired = this.$moment(this.propertyData.data.expire_date).format('YYYY-MM-DD');
        });
    },

    loadingCustomerById: function(id) {
      customerService.getOne(id)
        .then(response => {

          this.customerSelected = response.data;

          // console.log(JSON.stringify(this.customerSelected));
          this.dataCustomer = `${this.customerSelected.name } - (${this.customerSelected.name_en })`;
        });
    },

    loadingCustomerData: function() {
      customerService.getList()
        .then(response => {
          
          this.customerData = response;
        });
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "booking-list"
            });

        }
      });

      
    },

    submitSave: function() {
      this.tryingToSubmit = true;

      let obj = {
        id: this.$route.params.id,
        expire_date: this.dataExpired,
        notation: this.dataNotation,
      };

      // console.log(JSON.stringify(customer));
      bookingService.delay(obj)
        .then(response => {
        this.tryingToSubmit = false;

        if(response.status == 200) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "booking-list"
            });

              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message-edit'),
                icon: "success",
                confirmButtonText: i18n.t('general.ok')
              });
        }
      });

      
    },

    clearForm: function() {
      this.dataCode = '';
      this.dataCustomer = '';
      this.dataNotation = '';
      this.dataExpired = '';
    },
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('property.list'),
        href: '/general/property',
      }, {
        text: $t('property.new'),
        active: true
      }]" :title="this.isAdd ? $t('booking.delay') + ' ' + $t('property.text') : $t('booking.delay') + ' ' + $t('property.text')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('property.list'),
        href: '/general/property',
      }, this.breadCrumb]" :title="this.isAdd ? $t('booking.delay') + ' ' + $t('property.text') : $t('booking.delay') + ' ' + $t('property.text')" />
    </div>
    <Loader :loading="fetchingStats">
      <b-form class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="dataCode"
                    :label="'property.text'" 
                    :require="true"
                  /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'temp_customer_id'"
                    :disabled="true"
                    v-model="dataCustomer"
                    :label="'customer.text'" 
                    :require="true"
                  /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'date'"
                    :id="'temp_expired'"
                    v-model="dataExpired"
                    :label="'property.block_till'" 
                    :require="true"
                  /> 
                </div>
              </div>
              
              <div class="row">
                <div class="col-lg-12">
                  <Area 
                    :rows="7"
                    :id="'temp_note'"
                    v-model="dataNotation"
                    :label="'property.notation'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">

                  <b-form inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </b-form>
     
                </div>
              </div>
            </div>
          </div>
        </div>

        
      </b-form>
    </Loader>
  </Layout>
</template>